import { Component, OnInit, EventEmitter, Output, NgModule, Input } from '@angular/core';
import { ImageUploadService } from '../../services/image-upload.service';
import notify from 'devextreme/ui/notify';
import { HttpErrorResponse } from '@angular/common/http';

import { CommonModule } from '@angular/common';
import { ImageCropperModule } from 'ngx-image-cropper';
import { Configuration } from '../../../app.constants';




class FileSnippet {
  static readonly IMAGE_SIZE = { width: 950, height: 720 };

  pending: boolean = false;
  status: string = 'INIT';

  constructor(public src: string, public file: File) { }
}


@Component({
  selector: 'bwm-image-upload',
  templateUrl: './imageupload.component.html',
  styleUrls: ['./imageupload.component.scss']
})
export class ImageuploadComponent {

  @Output() imageUploaded = new EventEmitter();
  @Output() imageError = new EventEmitter();
  @Output() imageLoadedToContainer = new EventEmitter();
  @Output() croppingCanceled = new EventEmitter();

  @Input()
  imageType: string;

  @Input()
  disableControl:boolean;

  selectedFile: FileSnippet;
  imageChangedEvent: any;
  fileToUpload: File = null;

  constructor(
    private imageService: ImageUploadService, public configuration: Configuration) {
  }

  private onSucces(imageUrl: string) {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'OK';
    this.imageChangedEvent = null;
    this.imageUploaded.emit(imageUrl);
  }

  private onFailure() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'FAIL';
    this.imageChangedEvent = null;
    this.selectedFile.src = '';
    this.imageError.emit('');
  }
  private onSignSucces(imageUrl: string) {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'OK';
    this.imageChangedEvent = null;
    this.imageUploaded.emit(imageUrl);
  }

  private onSignFailure() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'FAIL';
    this.imageChangedEvent = null;
    this.selectedFile.src = '';
    this.imageError.emit('');
  }

  imageCropped(file: File, image: File): FileSnippet | File {
    file = this.fileToUpload;
    if (this.selectedFile) {
      return this.selectedFile.file = file;
    }
    return this.selectedFile = new FileSnippet('', file);
  }

  imageLoaded() {
    this.imageLoadedToContainer.emit();
  }

  cancelCropping() {
    this.imageChangedEvent = null;
    this.croppingCanceled.emit();
  }

  processFile(event: any) {
    this.selectedFile = undefined;

    const URL = window.URL;
    let file, img;

    if ((file = event.target.files[0]) && (file.type === 'image/png' || file.type === 'image/jpeg')) {
      img = new Image();

      const self = this;
      img.onload = function () {
        self.imageChangedEvent = event;
      }
      // img.onload = function() {

      //    if (this.width > FileSnippet.IMAGE_SIZE.width && this.height > FileSnippet.IMAGE_SIZE.height) {
      //      self.imageChangedEvent = event;
      //    } else {

      //     notify({
      //       message:`Minimum width is ${FileSnippet.IMAGE_SIZE.width} and minimum heigth is ${FileSnippet.IMAGE_SIZE.height}`,
      //       position: {
      //           my: "center top",
      //           at: "center top"
      //       }
      //   }, "success", 3000);
      //       //self.toastr.error(`Minimum width is ${FileSnippet.IMAGE_SIZE.width} and minimum heigth is ${FileSnippet.IMAGE_SIZE.height}`, 'Error!');
      //    }
      // }
      this.fileToUpload = file;

      img.src = URL.createObjectURL(file);
    } else {
      notify({
        message: 'Unsupported File Type. Only jpeg and png is allowed!',
        position: {
          my: "center top",
          at: "center top"
        }
      }, "success", 3000);

      //this.toastr.error('Unsupported File Type. Only jpeg and png is allowed!', 'Error!');
    }
  }

  uploadImage() {


    if (this.selectedFile) {
   
      if (this.imageType === "Photo") {

        if (this.selectedFile.file.size > this.configuration.ImageSize) {
          alert("Image File Size Exceeds Max Allowed Size.");
          this.cancelCropping();
          return;
        }

      }
      else {

        if (this.selectedFile.file.size > this.configuration.SignSize) {
          alert("Sign Image File Size Exceeds Max Allowed Size.");
          this.cancelCropping();
          return;
        }
      }

      const reader = new FileReader();

      reader.addEventListener('load', (event: any) => {
        this.selectedFile.src = event.target.result;
        this.selectedFile.pending = true;
        
        if (this.imageType === "Photo") {
          this.imageService.uploadImage(this.selectedFile.file, this.configuration.StudentID).subscribe(
            (imageUrl: string) => {
              this.onSucces(imageUrl);
            },
            (errorResponse: HttpErrorResponse) => {
             this.onFailure();
              notify({
                message: errorResponse.error.errors[0].detail,
                position: {
                  my: "center top",
                  at: "center top"
                }
              }, "success", 3000);

              //this.toastr.error(errorResponse.error.errors[0].detail, 'Error!');

            })
        }
        else {
          this.imageService.uploadImageSign(this.selectedFile.file, this.configuration.StudentID).subscribe(
            (imageUrl: string) => {
              this.onSignSucces(imageUrl);
            },
            (errorResponse: HttpErrorResponse) => {
              this.onSignFailure();
              notify({
                message: errorResponse.error.errors[0].detail,
                position: {
                  my: "center top",
                  at: "center top"
                }
              }, "success", 3000);

              //this.toastr.error(errorResponse.error.errors[0].detail, 'Error!');

            })

        }
      });

      reader.readAsDataURL(this.selectedFile.file);
    }
  }

}

@NgModule({
  imports: [
    CommonModule,
    ImageCropperModule
  ],
  providers: [
    ImageUploadService
  ],
  exports: [
    ImageuploadComponent,
  ],
  declarations: [
    ImageuploadComponent
  ]
})
export class ImageUploadModule { }

